import React, { useState } from 'react';
import { Navbar } from '../../Components/Navbar';
import { Typography, Button, IconButton, TextField } from "@mui/material";
import FileFormat from '../../Components/fileFormat/FileFormat';
import SelectSheetType from '../../Components/Preset/SelectSheetType';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Dropzone from 'react-dropzone';
import Card from '@mui/material/Card';
import "./presetStyle.css"
import { uploadPresetTb, deletePresetTempTB, mappingPreset, createPresetTB, checkTBNameAvailable } from '../../services/api/StandAlone/preset';
import HeaderMapping from '../../Components/Preset/HeaderMapping';
import { useParams } from 'react-router';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import InfoIcon from '@mui/icons-material/Info';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { toast } from 'react-toastify';
import UploadButton from "../../myfin_v2/assets/icons/UploadButton.png";
import RefreshIcon from '@mui/icons-material/Refresh';
import {ReactComponent as InfoGrey} from "../../myfin_v2/assets/icons/infoGrey.svg";
import { ReactComponent as LeftArrow } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close_grey.svg";
const UploadPresetTb = () => {
  const history = useHistory();
  const params = useParams();

  const [viewFormat, setViewFormat] = useState(false);
  const [open, setOpen] = useState(false);
  const [isMaping, setIsMaping] = useState(false);
  const [header, setHeader] = useState({ fileName: "", headers: [], isShow: false, tempTBId: "" });
  const [error, setError] = useState({
    isError: false,
    text: ""
  });
  const [tbPresetName, setTbPresetName] = useState({
    name: "",
    error: false
  });
  const [isDisabled, setIsDisabled] = useState(true);
  const [isMapped, setIsMapped] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const HandleFileUpload = (acceptedFiles) => {
    setError({ ...error, isError: false, text: '' });
    if (acceptedFiles.length === 0) {
      return
    }
    
    if (acceptedFiles.length > 1) {
      swal("Warning", "Please upload only one file at a time.", "warning");
    }

    setFileCount(1);
    if (acceptedFiles[0].type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      setError({ ...error, isError: true, text: `${acceptedFiles[0].type} type of file not accepted.` });
      return
    }
    const formData = new FormData();
    formData.append('file', acceptedFiles[0]);

    uploadPresetTb(formData).then(res => {
      setHeader({ ...header, fileName: res.data?.fileName, headers: res.data?.headers, isShow: true, tempTBId: res.data?.presetTempTB_id });
    })
      .catch(err => swal("Error", err.response?.data?.error || "Error uploading file", "error"));
  }

  const DeleteTempTB = (tempTB_id) => {
    deletePresetTempTB(tempTB_id).then(res => {
      setHeader({ ...header, isShow: false });
      setIsMapped(false);
    }).catch(err => {
      setHeader({ ...header, isShow: false });
      swal("Error", err.response?.data?.error || "Error deleting temporary TB", "error");
    });

  }

  const MappingTB = (value) => {
    let data = { ...value, presetTempTbId: header.tempTBId }
    mappingPreset(data).then(res => {
      setIsMapped(true);
      setIsDisabled(false);
    }).catch(err => swal("Error", err.response?.data?.error || "Error mapping columns", "error"));
  }

  const HandleContinueClick = () => {
    if (!tbPresetName.name) {
      setTbPresetName({ ...tbPresetName, error: true });
      swal("Warning", "Please enter preset name.", "warning");
      return;
    }
    const data = {
      presetTempTbId: header.tempTBId,
      presetId: params.presetId,
      name: tbPresetName.name,
    }
    createPresetTB(data).then(res => {
      history.push(`/preset/${params.presetId}`);
    }).catch(err => {
      swal("Error", err.response?.data?.error ? err.response?.data?.error : "Error happing at the time of create upload TB.", "error")
    })
  }

  const CheckTBNameAvailable = () => {
    checkTBNameAvailable().then(response => {

    }).catch(error => {

    })
  }

  const isNewUI = true;

  return (
    <>
      {
        isNewUI ? (
        <div className='px-4 pt-3 pb-1'>

  <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
    <LeftArrow
      style={{ cursor: "pointer", marginRight: "10px", width: "14px", height: "14px" }}
      onClick={() => history.push(`/preset/${params.presetId}`)}
    />
    <span style={{ fontSize: "15px", color: "#111111" }}>
      Upload Trial Balance
    </span>
  </div>

  <div
    style={{
      background: "#ffffff",
      borderRadius: "16px",
      padding: "24px",
      display: "flex",
      minHeight: "670px",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      marginTop: "30px"
    }}
  >

    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", width: "1000px" }}>

      <div style={{ width: "400px" }}>
        <p style={{ fontSize: "16px", marginBottom: "6px", color: "#33584E", fontWeight: 500 }}>
          Preset Name
        </p>
        <TextField
          placeholder='Enter Preset Name'
          size="small"
          fullWidth
          value={tbPresetName.name}
          onChange={(e) =>
            setTbPresetName({ ...tbPresetName, error: false, name: e.target.value })
          }
         sx={{
          background: "#F4FAF5",
          border: "1px solid #c2e6d1",
          borderRadius: "10px",
          '& .MuiOutlinedInput-root': {
            borderRadius: "10px",
            '& fieldset': { borderColor: 'transparent' },
            '&:hover fieldset': { borderColor: 'transparent' },
            '&.Mui-focused fieldset': { borderColor: 'transparent' },
            '&:hover': { borderColor: 'transparent' },
            '&.Mui-focused': { boxShadow: 'none' },
            '& input': {
              padding: "8px 14px",
              fontSize: "14px",
              border: "none",
              color: "#205a46",
            },
            '& input:focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }
        }}
        />
      </div>

      <div style={{ display: "flex", gap: "12px", alignItems: "center", paddingBottom: "4px" }}>
        <span
          style={{ cursor: "pointer", fontSize: "15px", color: "#66827A", whiteSpace: "nowrap" }}
          onClick={() => setViewFormat(true)}
        >
          <InfoGrey style={{ marginRight: "3px", position: "relative", top: "-1px" }} />
          View format
        </span>

        <span style={{ color: "#D9D9D9", fontSize: "16px" }}>|</span>

        <span
          style={{
            fontSize: "15px",
            color: "#66827A",
            whiteSpace: "nowrap"
          }}
        >
          Upload as sheets
          <span
            style={{
              cursor: "pointer",
              marginLeft: "6px",
              color: "#2D8861",
              fontWeight: 600,
              textDecoration: "underline"
            }}
            onClick={() => setOpen(true)}
          >
            Change
          </span>
        </span>
      </div>

    </div>

    <div style={{ marginTop: "24px", width: "1000px" }}>
      <Dropzone multiple={false} onDrop={acceptedFiles => HandleFileUpload(acceptedFiles)}>
        {({ getRootProps, getInputProps }) => (
        <div
          {...getRootProps()}
          style={{
            borderRadius: "12px",
            height: "420px",
            width: "1000px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#F4FAF5",
            cursor: "pointer",
            gap: "20px",
            backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23C2E6D1' stroke-width='3' stroke-dasharray='10 12' stroke-linecap='round'/%3e%3c/svg%3e")`,
            }}
        >
            <input {...getInputProps()} />

            <p style={{ color: "#B3C0BD", marginBottom: "10px", fontSize: "18px" }}>
              Drag and drop your file here or
            </p>

            <button
              style={{
                border: "1px solid #C2E6D1",
                padding: "6px 16px",
                borderRadius: "8px",
                background: "transparent",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontColor: "#205a46", 
                fontSize:"18px"
              }}
            >
              <img
                src={UploadButton}
                alt="upload"
                style={{ width: "16px", height: "16px" }}
              />
              Upload
            </button>

            {
              error.isError && (
                <Typography style={{ color: "red", marginTop: "10px" }}>
                  {error.text}
                </Typography>
              )
            }

          </div>
        )}
      </Dropzone>
    </div>
    {fileCount > 0 && (
      <div
        style={{
          width: "1000px",        
          textAlign: "left",
          marginTop: "16px",
          fontSize: "15px",
          color: "#6B7280",
          fontWeight: 500
        }}
      >
        {fileCount} file{fileCount > 1 ? "s" : ""} uploaded
      </div>
    )}

    {
      header.isShow &&
      <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    width: "1000px",
    marginTop: "20px"
  }}
>

  <div
    style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 12px",
      border: "1px solid #E5E7EB",
      borderRadius: "8px",
      background: "#ffffff"
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <InsertDriveFileIcon style={{ color: "#22C55E" }} />
      <span style={{ marginLeft: "8px", fontSize: "14px" }}>
        {header.fileName}
      </span>
    </div>

    <CloseIcon
      style={{
        cursor: "pointer",
        color: "#9CA3AF",
        fontSize: "18px"
      }}
      onClick={() => DeleteTempTB(header.tempTBId)}
    />
  </div>

  {isMapped ? (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "4px", color: "#205A46", fontSize: "13px", fontWeight: 500 }}>
        <CheckCircleOutlineIcon style={{ fontSize: "16px" }} /> Mapped
      </div>
      <div
        style={{
          width: "28px",
          height: "28px",
          backgroundColor: "#F4FAF5",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer"
        }}
        onClick={() => setIsMaping(true)}
      >
        <RefreshIcon style={{ fontSize: "18px", color: "#205A46" }} />
      </div>
    </div>
  ) : (
    <span
      style={{
        color: "#03565A",
        cursor: "pointer",
        fontSize: "15px",
        fontWeight: 500,
        whiteSpace: "nowrap"
      }}
      onClick={() => setIsMaping(true)}
    >
      Start Mapping
    </span>
  )}
</div>
    }

  </div>
  <div
    style={{
      display: "flex",         
      justifyContent: "flex-end",
      marginTop: "20px",
      width: "100%"   
    }}
  >
      <button
        style={{
           background: isDisabled ? "#205A4680" : "#205A46",
           opacity: isDisabled ? 0.6 : 1,
          color: "#ffffff",
          padding: "8px 24px",
          borderRadius: "8px",
          border: "none",
          cursor: isDisabled ? "not-allowed" : "pointer",
          fontWeight: 600,
          fontSize: "14px",
          letterSpacing: "0.3px"
        }}
        onClick={HandleContinueClick}
        disabled={isDisabled}
      >
        Save and Continue
      </button>
    </div>
</div>

        ) : (
          <>
            <Navbar text='Preset' />

            <div className='px-4 py-3'>
              <button
                className="d-flex custom-font-600 custom-common-theme-text-color border-0 bg-color-inherit"
                onClick={() => history.push(`/preset/${params.presetId}`)}
              >
                <ArrowBackIcon className="mr-1" /> Back
              </button>
              <div>
                <p className='custom-font-600 font-size-24'>Upload Trial Balances</p>
                <p className='custom-font-500 font-size-16'>File you upload must contain Ledger code, ledger name, and current year amount.</p>
                <p className='custom-font-500 font-size-16 mb-0 mt-0' >
                  <span
                    className='font-weight-bold font-size-16 custom-common-theme-text-color cursor-pointer'
                    onClick={() => setViewFormat(true)}
                  >
                    Click here
                  </span> to view format
                </p>
              </div>
              <div className='mt-4'>
                <Card className='radius-8px' style={{ minHeight: "460px" }}>
                  <div className="d-flex justify-content-between px-3">
                    <p className='custom-font-500 font-size-16'>Preset Name <span className='text-danger'>*</span> </p>
                    <p> <ChangeCircleIcon className='mr-1 ' style={{ color: "#03565A " }} />
                      <span
                        onClick={() => setOpen(true)}
                        className='custom-font-500 font-size-16  custom-common-theme-text-color cursor-pointer'
                      >
                        Change upload mode
                      </span>
                    </p>
                  </div>

                  <div className='px-3'>
                    <TextField
                      id="outlined-basic"
                      placeholder='Enter preset name'
                      variant="outlined"
                      className='custom-bg-white-150 text-secondary border-danger'
                      value={tbPresetName.name}
                      name='name'
                      onChange={(e) => setTbPresetName({ ...tbPresetName, error: false, name: e.target.value })}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: tbPresetName.error && 'red',
                          },
                          '&:hover fieldset': {
                            borderColor: tbPresetName.error && 'red',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: tbPresetName.error && 'red',
                          },
                        },
                      }}
                    />
                  </div>

                  <div className='px-3 mt-4'>
                    <Dropzone onDrop={acceptedFiles => HandleFileUpload(acceptedFiles)}>
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div className='preset-section' {...getRootProps()}>
                            <input {...getInputProps()} />

                            <div className='preset-drop'>
                              <div className='d-flex align-items-center justify-content-center rounded-circle custom-bg-warning' style={{ height: "90px", width: "90px", }}>
                                <div><FolderCopyIcon className='drop-folder' /></div>
                              </div>
                              {
                                error.isError && <Typography className='text-danger' fontSize={"14px"}>{error.text}</Typography>
                              }
                              <p className='custom-font-600 font-size-16 m-0'>Upload files here to prepare financial statements</p>
                              <p className='custom-font-500 font-size-12 m-0'><span><InfoIcon style={{ color: "#D6D6D6" }} /></span> File must contain Ledger Code, Ledger Name, Net Balance for Current Year</p>
                            </div>

                          </div>
                        </section>
                      )}
                    </Dropzone>
                  </div>

                </Card>
              </div>

              {
                header.isShow &&
                <>
                  <div className='d-flex mt-3 justify-content-between bg-white p-2 radius-8px'>
                    <div className='d-flex'>
                      <div
                        className='mt-2 d-flex align-items-center justify-content-center'
                        style={{ height: "40px", width: "40px", borderRadius: "50%", backgroundColor: "#F8F8F8" }}
                        onClick={() => DeleteTempTB(header.tempTBId)}
                      >
                        <DeleteOutlineIcon />
                      </div>
                      <div
                        className='mt-1 ml-3 d-flex align-items-center justify-content-center px-3 radius-10px'
                        style={{ backgroundColor: "#F8F8F8" }}
                      >
                        <InsertDriveFileIcon />
                        <p className='m-0 font-size-16 ml-2 custom-font-600 '>{header?.fileName}</p>
                      </div>
                    </div>
                    {
                      isMapped ? <CheckCircleOutlineIcon className='custom-common-theme-text-color' /> :
                        <Button
                          className='custom-common-theme-text-color custom-font-600 font-size-16 text-capitalize '
                          variant="outlined"
                          style={{ border: "2px solid #03565A" }}
                          onClick={() => setIsMaping(true)}
                        >
                          Select columns
                        </Button>
                    }
                  </div>
                </>
              }

              <button
                className='text-capitalize custom-common-theme-bg-color font-size-16 custom-font-600 text-white mt-4 border-0 radius-6px px-3 py-2 shadow'
                variant="contained"
                onClick={() => HandleContinueClick()}
                disabled={isDisabled}
              >
                Save and Continue
              </button>
            </div>
          </>
          
        )
      }

      {viewFormat ? <FileFormat setViewFormat={setViewFormat} /> : null}
      <SelectSheetType setOpen={setOpen} setsingleFormat={() => {}} open={open} />
      <HeaderMapping
        header={header}
        isMaping={isMaping}
        setIsMaping={setIsMaping}
        HandleConfirm={(value) => MappingTB(value)}
      />
    </>
  );
}

export default UploadPresetTb;